export default __webpack_public_path__ + "static/media/icon-10k.8e3d932e.png";